import React from 'react';

import Tourists from 'src/components/Tourists';

import { PACKAGE_HOME_PATH, PAY_PATH } from '../../../../store/constants';

import RedirectToPage from '../../../../components/RedirectToPage';
import ClientContainer from '../../../../components/Client';
import { Container } from '../../../../routes/styles';

import type { PropsFromRedux } from '.';

export const TouristsRoute = (props: PropsFromRedux): JSX.Element => {
  const { isClientConfirmed, redirectToHome, redirectToPayment, isMobile } =
    props;

  if (redirectToHome) {
    return <RedirectToPage path={PACKAGE_HOME_PATH} />;
  }

  if (redirectToPayment) {
    return <RedirectToPage path={PAY_PATH} />;
  }

  return (
    <>
      <Container $isMobile={isMobile}>
        <ClientContainer />
      </Container>

      <Container $isMobile={isMobile} $isDisabled={!isClientConfirmed}>
        <Tourists />
      </Container>
    </>
  );
};
